import themeSize from "./theme-size"
export default {
  mixins: [themeSize],
  props: {
    borderless: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    themeClasses() {
      return {
        mm__theme: this.size || this.borderless,
        [`mm__theme-size__${this.size}`]: this.size,
        "mm__theme-border__less": this.borderless,
      }
    },
  },
}
